import { ShareableLinkMainInfo } from 'models/ShareableLink';
import { createContext } from 'react';

type ShareableLinkContextProps = {
  isLoggedIn: boolean;
  mainInfo: ShareableLinkMainInfo;
};

export default createContext<Partial<ShareableLinkContextProps>>({
  isLoggedIn: false,
  mainInfo: null,
});
